import { hexToRgb } from '@material-ui/core';

export function iosTransparent(hexColor: string): string {
    const rgbaColor = hexToRgb(`${hexColor}0`);
    return rgbaColor;
}
